import { Box, FormControlLabel, Grid, Section, Switch, Typography } from '@cmg/design-system';
import { useField } from 'formik';
import React from 'react';

export type Props = Readonly<{ submitting?: boolean }>;

const WallCrossSubForm: React.FC<Props> = ({ submitting }) => {
  const [WXField, , WXHelpers] = useField('isWallCrossEnabled');

  const onWXSwitchChange = React.useCallback(() => {
    WXHelpers.setTouched(true);
    WXHelpers.setValue(!WXField.value);
  }, [WXField.value, WXHelpers]);

  return (
    <Section title="Confidential Wall Cross">
      <Grid item md={6} sm={9} xs={12}>
        <Typography variant="body1">
          Adds the confidential status to the offering, allowing for the management of confidential
          wall cross investor communication prior to launch/publish. Offering visibility does not
          apply to the confidential status.
        </Typography>
      </Grid>
      <Grid item md={6} sm={9} xs={12}>
        <Box p={2}>
          <FormControlLabel
            control={<Switch onChange={onWXSwitchChange} />}
            label="Wall Cross"
            checked={WXField.value}
            disabled={submitting}
          />
        </Box>
      </Grid>
    </Section>
  );
};

export default WallCrossSubForm;
